export default "/images/questions.png?6f460929319379fc67ef77d452016985";